//tasks
export const TASK_LIST_REQUEST = 'TASK_LIST_REQUEST'
export const TASK_LIST_SUCCESS = 'TASK_LIST_SUCCESS'
export const TASK_LIST_FAILUR = 'TASK_LIST_FAILUR'

//create task
export const CREATE_TASK_REQUEST = 'CREATE_TASK_REQUEST'
export const CREATE_TASK_SUCCESS = 'CREATE_TASK_SUCCESS'
export const CREATE_TASK_FAILUR = 'CREATE_TASK_FAILUR'

//completed task
export const COMPLETED_TASK_REQUEST = 'COMPLETED_TASK_REQUEST'
export const COMPLETED_TASK_SUCCESS = 'COMPLETED_TASK_SUCCESS'
export const COMPLETED_TASK_FAILUR = 'COMPLETED_TASK_FAILUR'
